import { MessageType } from "@/pages-components/quote-new/use-quote";

/** Maps send-to-customer checkboxes to backend MessageType (Mail=0, SMS=1, MailAndSMS=2). */
const resolveSendToCustomerMessageType = (
  sendByMail: boolean,
  sendBySms: boolean
): MessageType | null => {
  if (sendByMail && sendBySms) {
    return MessageType.Both;
  }
  if (sendByMail) {
    return MessageType.Email;
  }
  if (sendBySms) {
    return MessageType.SMS;
  }
  return null;
};

export { resolveSendToCustomerMessageType };
